module.exports = __webpack_public_path__ + "img/avatar4.55e7906d.png";